import { Navigate, Route, Routes } from 'react-router-dom'
import DatTokenProtection from './DatTokenProtection'

export default function DatTokenProtectionRoutes() {
    return (
        <Routes>
            <Route index element={<DatTokenProtection />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
